import React from "react";

export default function Privacy() {
    return (
        <div className="pt-32 pb-24" data-testid="privacy-page">
            <div className="max-w-3xl mx-auto px-6 md:px-12">
                <p className="text-pep-primary text-sm uppercase tracking-widest font-medium mb-3">Legal</p>
                <h1 className="font-heading text-5xl sm:text-6xl tracking-tighter text-pep-navy font-medium mb-6">
                    Privacy Policy
                </h1>
                <p className="text-pep-muted text-sm mb-12">Last updated: {new Date().toLocaleDateString("en-AU", { year: "numeric", month: "long", day: "numeric" })}</p>

                <div className="space-y-8 text-pep-navy leading-relaxed">
                    <Section title="1. Information We Collect">
                        When you place an order or contact us, we collect: your name, email, shipping address, phone (optional), and order details. We do not collect or store payment card data — bank transfer is processed outside our systems.
                    </Section>
                    <Section title="2. How We Use Your Information">
                        We use your information to fulfil orders, send order confirmations and shipping updates, respond to your inquiries, and improve our service. We do not sell or rent your information to third parties.
                    </Section>
                    <Section title="3. Data Storage">
                        Order and contact data is stored in our secure database. We use industry-standard encryption in transit (HTTPS) and at rest. Access is restricted to authorised staff.
                    </Section>
                    <Section title="4. Third-Party Services">
                        We use Resend (email delivery) and our hosting provider to operate the Site. These providers only receive the minimum data necessary to deliver their services and are bound by their own privacy policies.
                    </Section>
                    <Section title="5. Cookies">
                        We use essential cookies to keep your cart populated across page reloads and to support basic site analytics. We do not use third-party advertising cookies.
                    </Section>
                    <Section title="6. Your Rights">
                        Under Australian Privacy Principles you have the right to access, correct, or delete the personal information we hold about you. To request this, email <a href="mailto:orders@pepstep.com" className="text-pep-primary hover:underline">orders@pepstep.com</a>.
                    </Section>
                    <Section title="7. Retention">
                        We retain order records for 7 years for tax and legal compliance, after which they are securely deleted. Contact form messages are retained for 24 months.
                    </Section>
                    <Section title="8. Updates">
                        We may update this policy from time to time. Material changes will be noted at the top of this page.
                    </Section>
                    <Section title="9. Contact">
                        Privacy questions? Email <a href="mailto:orders@pepstep.com" className="text-pep-primary hover:underline">orders@pepstep.com</a>.
                    </Section>
                </div>
            </div>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <div>
            <h2 className="font-heading text-2xl font-medium text-pep-navy mb-3">{title}</h2>
            <p className="text-pep-muted">{children}</p>
        </div>
    );
}
